import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FaBuilding } from "react-icons/fa";

const jobExperiences = [
  {
    id: 1,
    date: "January 2023 - Present",
    position: "Front End Engineer",
    company: "SERIANU LIMITED",
    description:
      "As a Front-End Engineer, I played a pivotal role in shaping the user experience for the CyberShujaa platform across mobile and web by designing end-to-end solutions through Figma. I leveraged advanced web development technologies, including React, PostgreSQL, MaterialUI, Typescript, CSS, HTML, and JavaScript Object Notation, to build robust and scalable applications. Conducting user testing sessions, I gathered valuable feedback, validated product features, and refined brand perception. Additionally, I crafted a responsive landing page and dashboard using React, Next.js, and Material-UI, incorporating key components such as headers, cards, and forms to ensure an intuitive and user-friendly interface.",
  },
  {
    id: 2,
    date: "September 2020 - 2022",
    position: "Software Developer, Consultant",
    company: "UN-HABITAT ( United Nations Settlement Programme )",
    description:
      "I worked closely with designers to craft clean interfaces and ensure simple, intuitive interactions for various web applications. My responsibilities extended to testing REST endpoints using POSTMAN, ensuring the robustness of backend functionalities. A notable project involved the design and development of the participatory Habitat Platform website, leveraging React Js to create a dynamic and engaging user experience. Additionally, I integrated the React application with a headless CMS, specifically Strapi, for seamless content management. Beyond Strapi, I also possess proficiency in content management for WordPress and Drupal sites, enhancing my versatility in managing diverse web platforms.",
  },
  {
    id: 3,
    date: "January 2019 - March 2020",
    position: "Software Developer Intern",
    company: "UN-HABITAT ( United Nations Settlement Programme )",
    description:
      "In a pivotal role, I designed and built the Participatory Budgeting Platform for Escobedo City in Mexico, a transformative initiative aimed at fostering citizen engagement and bolstering fiscal transparency. Concurrently, I configured Jenkins and GitLab to establish a robust continuous integration and deployment architecture, enhancing collaboration and efficiency within the development process. Additionally, I orchestrated the implementation of Docker containers and Kubernetes, introducing an automated scaling infrastructure that dynamically adapts to workloads. This initiative optimized resource utilization and ensured seamless scalability for the deployed applications, contributing to a more agile and efficient technological ecosystem.",
  },
];

export default function Timeline() {
  const theme = useTheme();

  return (
    <Box sx={{ marginTop: "40px" }}>
      <ul className="timeline">
        {jobExperiences.map((job) => (
          <li key={job.id} className="timeline-event">
            <label className="timeline-event-icon"></label>
            <div className="timeline-event-copy">
              <p className="timeline-event-thumbnail">{job.date}</p>
              <Box
                sx={{
                  color: "rgb(128, 128, 128)",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FaBuilding />
                <p className="company">{job.company}</p>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  color: theme.palette.common.yellow,
                  letterSpacing: "1px",
                  lineHeight: "58px",
                  width: "80%",
                }}
              >
                {job.position}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "rgb(128, 128, 128)",
                  fontSize: "16px",
                  fontWeight: 200,
                  marginTop: "15px",
                  width: "97.2%",
                }}
              >
                {job.description}
              </Typography>
            </div>
          </li>
        ))}
      </ul>
    </Box>
  );
}
